import Card from "@/atoms/Card";
import SubLayout from "@/containers/layout/LandingLayout/SubLayout";

import WinWIn from "@/public/intermediaries/win-win.svg?url";
import PurchasingPower from "@/public/intermediaries/purchasing-power.svg?url";
import EasyKeyzy from "@/public/intermediaries/easy-keyzy.svg?url";
import BuiltForBrokers from "@/public/intermediaries/built-for-brokers.svg?url";
import TrulyRewarding from "@/public/intermediaries/truly-rewarding.svg?url";

import HorizontalBar from "@/atoms/HorizontalBar";
import VerticalBar from "@/atoms/VerticalBar";

const CompanyFeatures = (): JSX.Element => {
  return (
    <SubLayout allowOverflow className="bg-white xl:pb-10">
      <section className="relative w-full py-16 md:pb-0">
        <div id="why" className="absolute top-0" />
        <h2 className="text-4xl font-bold text-center xl:text-5xl text-landing-blue mb-11 xl:mb-14">
          Why Keyzy
        </h2>
        <div className="flex flex-col md:flex-row md:justify-center md:h-60">
          <Card
            title="It’s a win-win"
            subtitle="Always have an offer for your clients, with our Zero Deposit solution."
            image={WinWIn}
          />

          <HorizontalBar className="my-4 md:hidden" />
          <VerticalBar className="hidden md:inline-block md:mx-20 xl:mx-28" />

          <Card
            title="Keyzy purchasing power"
            subtitle="Our all-cash offer helps your clients move with speed and win in competitive markets."
            image={PurchasingPower}
          />
          <HorizontalBar className="my-4 md:hidden" />
        </div>

        <HorizontalBar className="hidden w-full md:my-11 xl:my-14 md:inline-block" />

        <div className="block h-64 md:flex md:justify-center md:flex-row mb-11">
          <Card
            title="Easy Keyzy"
            subtitle="Generate a budget in principle in under 2 minutes."
            size="small"
            image={EasyKeyzy}
          />

          <HorizontalBar className="inline-block my-4 md:hidden" />
          <VerticalBar className="hidden md:inline-block md:mx-7 xl:mx-20" />

          <Card
            title="Built for brokers"
            subtitle="Designed to help you painlessly track applicants and rewards."
            size="small"
            image={BuiltForBrokers}
          />
          <HorizontalBar className="inline-block my-4 md:hidden" />
          <VerticalBar className="hidden md:inline-block md:mx-7 xl:mx-20 " />

          <Card
            title="Truly rewarding"
            subtitle="Outstanding work deserves outstanding rewards."
            size="small"
            image={TrulyRewarding}
          />
        </div>
      </section>
    </SubLayout>
  );
};

export default CompanyFeatures;
